'use strict';
var path = require('path');
var prefix = '';

// 如果是 mockplus 的, 要到根目录下面去找
if (window.mockplus) {
  prefix = '/';
}

// 开发的时候,到 dist/ 目录下面去找
if (window.isDev) {
  prefix = 'dist/';
}

/**
 * 根据资源的相对路径查找真实路径
 * @param p
 * @returns {string}
 */
exports.getAsset = function (p) {
  return path.join(prefix + 'assets/', p);
};

/**
 * 获取组件的素材
 * @param name
 * @returns {string}
 */
exports.getComponentAsset = function (name) {
  name = name || '';
  return prefix + 'assets/components/wireframe/' + name.toLowerCase() + '.png'; // 这里始终使用线框素材
};

/**
 * 获取图标
 * @param filename
 * @returns {string}
 */
exports.getIcon = function (filename) {
  filename = filename || '';
  return prefix + 'assets/icons/wireframe/' + filename.toLowerCase(); // 始终使用线框图标
};

/**
 * 获取辅助素材资源
 * @param finename
 * @returns {string}
 */
exports.getAssistAsset = function (finename) {
  return prefix + 'assets/components/wireframe/commons/' + finename.toLowerCase();
};

exports.getLogo = function () {
  return prefix + 'assets/logo.png';
};



/** WEBPACK FOOTER **
 ** ./src/helper/assetsHelper.js
 **/